import Stamp from '../../../../../../../../types/api/stamp'
import FormValues from '../types/form-values'

export default function getInitialValues(stamp?: Stamp): FormValues {
    if (stamp)
        return {
            tube: stamp.tube?.documentId || '',
            number: stamp.number,
            width: stamp.width,
            length: stamp.length,
            floods: stamp.floods,
            range: stamp.range,
            shape: stamp.shape,
            quantity: stamp.quantity,
            comment: stamp.comment,
            locked: stamp.locked,
            imageLink: stamp.imageLink,
            layoutLink: stamp.layoutLink,
            materialGroups: stamp.material_groups?.map(x => x.documentId) || [],
            roller: stamp.roller?.documentId || '',
            contractor: stamp.contractor?.documentId || '',
            radius: stamp.radius,
            externalId: stamp.externalId,
            approximateCost: stamp.approximateCost,
        }

    return {} as FormValues // TODO: поправить
}
